import { Switch } from 'react-router-dom';
import { SiteFooter } from 'bv-components';
import {
  BetCalculator,
} from '../routing/components/main_routes/lazy_components';
import { MiniGames, MiniLaunch } from './lazy_components';
import { Route } from '../routing/components/shared';

const EmbeddedRoutesView = () => (
  <div className="embedded-content">
    <Switch>
      <Route path="/components/bet-calculator">
        <BetCalculator />
        <SiteFooter />
      </Route>
      <Route exact path="/components/mini-games/:slug?">
        <MiniGames />
      </Route>
      <Route exact path="/components/mini-games/:gameId/launch">
        <MiniLaunch />
      </Route>
    </Switch>
  </div>
);

export default EmbeddedRoutesView;
